import { EditableText } from "@/components/EditableText";

// Nome ed eventuale slogan del sito, modificabili dall'admin (slot brand_name/brand_name_accent/brand_slogan).
export function BrandText({
  nameClassName = "font-display text-2xl font-semibold",
  sloganClassName = "text-[11px] text-muted-foreground tracking-wide",
  showSlogan = true,
}) {
  return (
    <>
      <span className={nameClassName}>
        <EditableText slot="brand_name" defaultText="OPES" /> <span className="text-gold"><EditableText slot="brand_name_accent" defaultText="Ginnastiche" /></span>
      </span>
      {showSlogan && (
        <span className={sloganClassName}>
          <EditableText slot="brand_slogan" defaultText="Risorse che generano valore" />
        </span>
      )}
    </>
  );
}
